import React from 'react';
import { Typography } from 'extended-oxygen-elements';

type Props = {
  children: React.ReactNode;
};

export function SummaryLabel({ children }: Props) {
  return (
    <Typography variant="caption" color="textSecondary" gutterBottom>
      {children}
    </Typography>
  );
}
